__turbopack_context__.v({
  "bottomGap": "Window-module-scss-module__iGoRYW__bottomGap",
  "breadcrumbs": "Window-module-scss-module__iGoRYW__breadcrumbs",
  "closeButton": "Window-module-scss-module__iGoRYW__closeButton",
  "window": "Window-module-scss-module__iGoRYW__window",
});
